import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  OccEndpointsService,
  ConverterService,
  Occ,
  OCC_CART_ID_CURRENT,
} from '@spartacus/core';
import { Observable } from 'rxjs';
import { pluck, map } from 'rxjs/operators';
import {OccCartAdapter} from '@spartacus/cart/base/occ';
import {CartAdapter} from '@spartacus/cart/base/core';
import {Cart, CART_NORMALIZER} from "@spartacus/cart/base/root";

@Injectable()
export class UigOccCartAdapter extends OccCartAdapter implements CartAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpointsService: OccEndpointsService,
    protected converterService: ConverterService
  ) {
    super(http, occEndpointsService, converterService);
  }

  public loadAll(userId: string): Observable<Cart[]> {
    return this.http
      .get<Occ.CartList>(this.occEndpointsService.buildUrl('carts', {urlParams: { userId }}))
      .pipe(
        pluck('carts'),
        this.converterService.pipeableMany(CART_NORMALIZER),
      );
  }

  public load(userId: string, cartId: string): Observable<Cart> {
    if (cartId === OCC_CART_ID_CURRENT) {
      return this.loadAll(userId).pipe(
        map((carts) => {
          if (carts) {
            const activeCart = carts.find((cart) => {
              return ((cart['saveTime'] === undefined && cart['publicCart'] == false) || 
              (cart['saveTime'] === undefined && cart['publicCart'] == true && cart['activeCartForUser'] == true));
            });
            return activeCart;
          } else {
            return null;
          }
        })
      );
    } else {
      return this.http
        .get<Occ.Cart>(
          this.occEndpointsService.buildUrl('cart', {urlParams: { userId, cartId }})
        )
        .pipe(this.converterService.pipeable(CART_NORMALIZER));
    }
  }
}
